import { ClienteGraficoAdimplenciaResponse } from "../typings";
import axios from "infra/http";
import { useQuery } from "react-query";

function useClientesGraficoAdimplencia() {
  return useQuery(
    `/v1/cliente/grafico-adimplencia`,
    async () => {
      const res = await axios.get<ClienteGraficoAdimplenciaResponse>('/v1/cliente/grafico-adimplencia');

      return res.data;
    },
  );
}

export default useClientesGraficoAdimplencia;
